export default {
    rowSelection: false,
    fieldControl: false,
    searchFormConfig: {
      labelCol: {
        xs: {span: 24},
        sm: {span: 8},
        xl: {span: 10},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
        xl: {span: 14},
      },
    },
    scroll: {y: 350},
    columns: [
      {
        title: '到店时间',
        dataIndex: 'arrivedDate',
        itemType: 'dateTime',
        width: 180,
      },
      {
        title: '线索ID',
        dataIndex: 'id',
        width: 180,
        render: 'clueIdRender'
      },
      {
        title: '客户姓名',
        dataIndex: 'name',
        width: 160,
        render: 'nameRender'
      },
      {
        title: '客户电话',
        dataIndex: 'phone',
        render: 'checkPhone',
        width: 160,
      },
      {
        title: '楼盘名称',
        dataIndex: 'buildingName',
        width: 160,
        ellipsis: true,
      },
      {
        title: '客户来源',
        dataIndex: 'channelName',
        width: 260,
        ellipsis: true,
      },
    ],
   
    footer: [
    ],
  };
  